import React, { FC, ReactElement, useEffect, useState } from 'react';
import classes from './Users.module.scss';
import { UsersTable } from '../../Components/UsersTable';
import { useUsers } from '../../hooks/entityHooks';
import { PreLoader } from '../../Components/PreLoader';
import { AddUserDialog } from '../../Components/Dialogs/AddUserDialog';

export const Users: FC = (): ReactElement => {
  const { entityList: list, getEntityList, initLoading } = useUsers();
  const [block, setBlock] = useState(false);
  useEffect(() => {
    const result = getEntityList();
  }, []);

  const handleChange = () => {
    getEntityList();
  };

  const handleGetList = () => {
    getEntityList();
  };

  return (
    <>
      {initLoading ? (
        <PreLoader />
      ) : (
        <div className={classes.body}>
          <div className={classes.body__adduser}>
            <AddUserDialog handleGetList={handleGetList} />
          </div>

          <table className={classes.body__table}>
            <thead className={classes.body__table__head}>
              <tr className={classes.body__table__head__tr}>
                <td>Email</td>
                <td>Фамилия и Имя</td>
                <td>Роль</td>
                <td>Статус</td>
                <td>Действия</td>
              </tr>
            </thead>
            <tbody className={classes.body__table__body}>
              {list.length ? (
                <UsersTable list={list} handleChange={handleChange} />
              ) : null}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};
